import wrapPage from "./src/wrapPageElement"

export const wrapPageElement = wrapPage
